<template>
    <div>
      <loading :active.sync="loader.isLoading" :can-cancel="loader.canCancel" :is-full-page="loader.fullPage" :color="loader.color" :height="loader.height" :width="loader.width" :background-color="loader.backgroundColor" :loader="loader.loader"></loading>
      <div class="card">
          <div class="card-header">
              <h5>Buku Besar</h5>
          </div>
          <div class="card-body">
              <div class="row">
                <div class="col-md-6">
                    <div class="form-group row">
                        <label for="account_code" class="col-sm-3 col-form-label text-left">Account</label>
                        <div class="col-sm-9">
                            <v-select :options="getAccountSelect" :reduce="account => account.meta.code" label="account" v-model="account_code" :multiple="true"/>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="month" class="col-sm-3 col-form-label text-left">Date</label>
                        <div class="col-sm-9">
                            <date-picker v-model="startDate" type="date" range placeholder="Select date range"></date-picker>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="month" class="col-sm-3 col-form-label text-left">Contact</label>
                        <div class="col-sm-9">
                            <v-select :options="contactSelect" :reduce="contact => contact.meta.code" label="contact" v-model="contact" class="vsc-custom"/>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="month" class="col-sm-3 col-form-label text-left">Term</label>
                        <div class="col-sm-9">
                          <select v-model="term" class="form-control">
                            <option value="saldo">Saldo</option>
                            <option value="non-saldo">Not include Saldo</option>
                          </select>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="product_no" class="col-sm-3 col-form-label text-left">Product</label>
                        <div class="col-sm-9">
                            <v-select :options="productselect" :reduce="product => product.meta.code" label="product" v-model="product_no"/>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label for="year" class="col-sm-3 col-form-label text-left">&nbsp;</label>
                        <div class="col-sm-9">
                            <button type="button" class="btn btn-soft-primary" @click="refreshList">Search</button>
                            <button type="button" class="btn btn-soft-primary" @click="getProductCost">Get Cost</button>
                            <button type="button" class="btn btn-soft-primary" @click="setCost">Set Cost</button>
                            <button class="btn btn-warning pull-right dropdown-toggle" type="button" id="print" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i class="fa fa-print" aria-hidden="true"></i> Print</button>
                            <div class="dropdown-menu" aria-labelledby="print">
                                <a class="dropdown-item" href="javascript:void(0)" @click="print('pdf')">PDF</a>
                                <a class="dropdown-item" href="javascript:void(0)" @click="print('excel')">Excel</a>
                            </div>
                        </div>
                    </div>
                </div>
              </div>
              <hr>
              <div class="row">
                  <div class="col-md-12">
                    <ul class="nav nav-tabs nav-bordered">
                      <li class="nav-item"><a href="#data-buku-besar" data-toggle="tab" aria-expanded="false" class="nav-link active">Data</a></li>
                      <li class="nav-item"><a href="#data-buku-besar-before" data-toggle="tab" aria-expanded="false" class="nav-link">Data Before</a></li>
                      <li class="nav-item"><a href="#data-buku-besar-account-saldo" data-toggle="tab" aria-expanded="false" class="nav-link">Data Account</a></li>
                      <li class="nav-item"><a href="#data-buku-besar-group-acount-saldo" data-toggle="tab" aria-expanded="false" class="nav-link">Data Group</a></li>
                    </ul>
                    <div class="tab-content">
                      <div class="tab-pane active" id="data-buku-besar">
                        <div class="table-responsive">
                          <span>Rows: <b>{{ journal.length | currency }}</b></span>
                          <span class="float-right font-14">Saldo Akhir: <b>{{ saldoAkhir }}</b></span>
                          <span class="float-right font-14 mr-1">Saldo Awal: <b>{{ saldoAwal | currency }}</b></span>
                          <div class="table responsive">
                            <table class="table table-item mb-0 table-sm table-striped table-hover">
                                <thead>
                                    <th>Date</th>
                                    <th>Journal No.</th>
                                    <th>Ref No.</th>
                                    <th>Remark</th>
                                    <th class="text-right">Debit</th>
                                    <th class="text-right">Credit</th>
                                    <th class="text-right">Saldo</th>
                                    <th class="text-right">Cost</th>
                                    <th class="text-right">Diff</th>
                                    <th>#</th>
                                </thead>
                                <tbody>
                                    <tr v-for="j in journal" :key="j.id">
                                        <td>{{ j.journal_date | dateFormat('DD/MM/YYYY') }}</td>
                                        <td>
                                          <span @click="editJournal(j.jid)" data-toggle="modal" data-target="#modalJournalData" data-backdrop="static" data-keyboard="false">
                                            <b style="cursor: pointer;">{{ j.journal_code }}</b>
                                          </span>
                                        </td>
                                        <td>
                                          <span class="text-ref-sales" @click="showSaleNo(j.j_ref_no)" data-toggle="modal" data-target="#modalSalesByNo" data-backdrop="static" data-keyboard="false" v-if="j.type === 'sales'">{{ j.j_ref_no }}</span>
                                          <span class="text-ref-sales" @click="showReturSales(j.j_ref_no)" data-toggle="modal" data-target="#modalReturn" data-backdrop="static" data-keyboard="false" v-else-if="j.type === 'return sales'">{{ j.j_ref_no }}</span>
                                          <span class="text-ref-sales" v-else>{{ j.j_ref_no }}</span>
                                          {{ j.type }}
                                        </td>
                                        <td>{{ j.remark }}</td>
                                        <td class="text-right">{{ j.debit | currency }}</td>
                                        <td class="text-right">{{ j.credit | currency }}</td>
                                        <td class="text-right">{{ j.saldo }}</td>
                                        <td class="text-right">{{ j.cost }}</td>
                                        <td class="text-right">{{ j.diff }}</td>
                                        <td><button type="button" class="btn btn-sm btn-hard-primary"><i class="fa fa-refresh"></i></button></td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                  <tr>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td class="text-right">{{ totalDebit | currency }}</td>
                                    <td class="text-right">{{ totalCredit | currency }}</td>
                                    <td class="text-right">{{ totalDebit - totalCredit | currency }}</td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                  </tr>
                                  <tr>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td class="text-right"><i>Saldo in range date (coa)</i></td>
                                    <td class="text-right"><b>{{ saldoRange | currency }}</b></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                  </tr>
                                  <tr>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td class="text-right"><i><h5>Saldo</h5></i></td>
                                    <td class="text-right"><h5><b>{{ saldoAkhir }}</b></h5></td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                  </tr>
                                </tfoot>
                            </table>
                          </div>
                        </div>
                      </div>
                      <div class="tab-pane" id="data-buku-besar-before">
                        <div class="table responsive">
                          <table class="table table-item mb-0 table-sm table-striped table-hover">
                              <thead>
                                  <th>Date</th>
                                  <th>Journal No.</th>
                                  <th>Ref No.</th>
                                  <th>Remark</th>
                                  <th class="text-right">Debit</th>
                                  <th class="text-right">Credit</th>
                                  <th class="text-right">Saldo</th>
                              </thead>
                              <tbody>
                                  <tr v-for="j in dataBefore" :key="j.id">
                                      <td>{{ j.journal_date | dateFormat('DD/MM/YYYY') }}</td>
                                      <td>
                                        <span @click="editJournal(j.jid)" data-toggle="modal" data-target="#modalJournalData" data-backdrop="static" data-keyboard="false">
                                          <b style="cursor: pointer;">{{ j.journal_code }}</b>
                                        </span>
                                      </td>
                                      <td>{{ j.j_ref_no }}</td>
                                      <td>{{ j.remark }}</td>
                                      <td class="text-right">{{ j.debit | currency }}</td>
                                      <td class="text-right">{{ j.credit | currency }}</td>
                                      <td class="text-right">{{ j.saldo }}</td>
                                  </tr>
                              </tbody>
                          </table>
                        </div>
                      </div>
                      <div class="tab-pane" id="data-buku-besar-account-saldo">
                        <div class="row">
                          <div class="col-md-12">
                            <div class="table-responsive">
                              <h5>Account Saldo</h5>
                              <table class="table table-item mb-0 table-sm table-striped table-hover">
                                  <thead>
                                      <th>Date</th>
                                      <th>Account</th>
                                      <th>Product</th>
                                      <th class="text-right">Debit</th>
                                      <th class="text-right">Credit</th>
                                  </thead>
                                  <tbody>
                                    <tr v-for="(a, index) in dataAccount" :key="index">
                                      <td>{{ a.date | dateFormat('DD/MM/YYYY') }}</td>
                                      <td>{{ a.account_code }}</td>
                                      <td>{{ a.product_no }}</td>
                                      <td class="text-right">{{ a.debit | currency }}</td>
                                      <td class="text-right">{{ a.credit| currency }}</td>
                                    </tr>
                                  </tbody>
                                  <tfoot>
                                    <tr>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td class="text-right">{{ totalDebitAccountsaldo | currency }}</td>
                                      <td class="text-right">{{ totalCreditAccountsaldo | currency }}</td>
                                    </tr>
                                  </tfoot>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="tab-pane" id="data-buku-besar-group-acount-saldo">
                        <div class="table-reponsive">
                          <!-- <table class="table table-item mb-0 table-sm table-striped table-hover">
                            <thead>
                              <th>Product No</th>
                              <th>Debit</th>
                              <th>Credit</th>
                            </thead>
                            <tbody>
                              <tr v-for="(i, index) in mergeColl" :key="index">
                                <td>{{ i.product_no }}</td>
                                <td>{{ i.debit | currency }}</td>
                                <td>{{ i.credit | currency }}</td>
                              </tr>
                            </tbody>
                          </table> -->
                          <span>Total Saldo: <b>{{ totalgroupMergeColl | currency }}</b></span>
                          <table class="table table-item mb-0 table-sm table-striped table-hover">
                            <thead>
                              <th>Product No</th>
                              <th>Product Type</th>
                              <th class="text-right">Debit</th>
                              <th class="text-right">Credit</th>
                              <th class="text-right">Saldo</th>
                            </thead>
                            <tbody>
                              <tr v-for="(i, index) in groupMergeColl" :key="index">
                                <td>{{ i.product_no }}</td>
                                <td>{{ i.product_type }}</td>
                                <td class="text-right">{{ i.debit | currency }}</td>
                                <td class="text-right">{{ i.credit | currency }}</td>
                                <td class="text-right">{{ i.saldo | currency }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div class="row">
                          <div class="col-md-4">
                            <pre>{{ groupMergeColl }}</pre>
                          </div>
                          <div class="col-md-4">
                            <pre>{{ dataBefore }}</pre>
                          </div>
                          <div class="col-md-4">
                            <pre>{{ dataAccount }}</pre>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
              </div>
          </div>
          <div class="card-footer"></div>
      </div>
      <JournalModal />
      <SaleModal />
      <ReturnModal />
      <pre>{{ groupCost }}</pre>
    </div>
</template>
<script>
import Axios from 'axios'
import { financeUrl, getHeader, productUrl, report2Url } from '../../config'
import { mapState } from 'vuex'
import JournalModal from '@/components/journal/JournalModal.vue'
import DatePicker from 'vue2-datepicker'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import SaleModal from '@/components/sales/SaleModal.vue'
import ReturnModal from '@/components/return/ReturnModal.vue'

export default {
  name: 'BukuBesarPersediaan',
  components: {
    JournalModal,
    DatePicker,
    Loading,
    SaleModal,
    ReturnModal
  },
  data () {
    var date = new Date()
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
    var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)
    const date1 = new Date(firstDay.getFullYear(), firstDay.getMonth(), firstDay.getDate())
    const date2 = new Date(lastDay.getFullYear(), lastDay.getMonth(), lastDay.getDate())
    return {
      dataCost: [],
      term: 'saldo',
      dataAccount: [],
      dataBefore: [],
      product_no: null,
      company_no: null,
      startDate: [date1, date2],
      account_code: [],
      month: date.getMonth() + 1,
      year: date.getFullYear(),
      saldoAwal: '0',
      saldoRange: '0',
      saldoAkhir: '0',
      contact: null,
      journal: [{
        no: null,
        jid: null,
        id: null,
        journal_code: null,
        account_code: null,
        remark: null,
        debit: 0,
        credit: 0,
        saldo: null,
        branch_no: null,
        journal_date: null,
        account: {
          id: null,
          type_code: null,
          account_code: null,
          account_name: null,
          notes: null,
          account_balance: null,
          group_id: null,
          method: null
        }
      }],
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: true /* doesn't work with directive */
      },
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      }
    }
  },
  mounted () {
    this.$store.dispatch('getAccountList')
    this.$store.dispatch('getCompanyList')
    this.$store.dispatch('getJournalContacts')
    this.$store.dispatch('getProductListSelect')
    // const local = window.localStorage.getItem('authUser')
    // this.company_no = null
  },
  computed: {
    ...mapState({
      accountList: state => state.accounts.accountList,
      companyList: state => state.companies.companyList,
      authUser: state => state.users.authUser,
      contactList: state => state.journals.journalContacts,
      productListSelect: state => state.products.productListSelect
    }),
    groupCost () {
      var result = []
      if (this.dataCost.length > 0) {
        this.dataCost.reduce(function (res, value) {
          // key = Date.parse(value.cost_date) + value.queue + value.company_no
          var key = value.company_no + value.queue
          if (!res[key]) {
            var refNo = null
            var price = 0
            var qtyIn = 0
            var qtyOut = 0
            var qtySaldo = 0
            var uomIn = null
            var uomOut = null
            var uomSaldo = null
            var priceIn = 0
            var priceOut = 0
            var priceSaldo = 0
            var refNoIn = null
            var refNoOut = null
            var statusIn = null
            var statusOut = null
            var vendor = null
            var customer = null
            var totalIn = 0
            var totalOut = 0
            var totalSaldo = 0
            var out = []
            var saldo = []
            if (value.type === 'in') {
              qtyIn = value.cost_qty
              uomIn = value.uom_id
              priceIn = value.cost_amount
              refNoIn = value.ref_no
              refNo = value.ref_no
              price = parseFloat(value.cost_amount)
              statusIn = value.status
              vendor = value.purchasing.vendor
              totalIn = parseFloat(value.cost_qty) * parseFloat(value.cost_amount)
            } else if (value.type === 'out') {
              qtyOut = value.cost_qty
              uomOut = value.uom_id
              priceOut = value.cost_amount
              customer = value.sales.customer
              refNoOut = value.ref_no
              refNo = value.ref_no
              price = parseFloat(value.cost_amount)
              statusOut = value.status
              out.push({
                qtyOut: value.cost_qty,
                uomOut: value.uom_id,
                priceOut: value.cost_amount,
                refNoOut: value.ref_no,
                customer: value.sales.customer,
                status: value.status,
                notes: value.notes
              })
              totalOut = parseFloat(value.cost_qty) * parseFloat(value.cost_amount)
            } else if (value.type === 'saldo') {
              qtySaldo = value.cost_qty
              uomSaldo = value.uom_id
              priceSaldo = value.cost_average
              saldo.push({
                qtySaldo: value.cost_qty,
                uomSaldo: value.uom_id,
                priceSaldo: value.cost_average,
                refNoSaldo: value.ref_no,
                status: value.status,
                queue_saldo: value.queue_saldo,
                notes: value.notes
              })
              totalSaldo = parseFloat(value.cost_qty) * parseFloat(value.cost_average)
            }
            res[key] = {
              date: value.cost_date,
              refNo: refNo,
              price: price,
              qtyIn: qtyIn,
              uomIn: uomIn,
              priceIn: priceIn,
              refNoIn: refNoIn,
              statusIn: statusIn,
              vendor: vendor,
              totalIn: totalIn,
              qtyOut: qtyOut,
              uomOut: uomOut,
              priceOut: priceOut,
              refNoOut: refNoOut,
              statusOut: statusOut,
              customer: customer,
              out: out,
              totalOut: totalOut,
              qtySaldo: qtySaldo,
              uomSaldo: uomSaldo,
              priceSaldo: priceSaldo,
              saldo: saldo,
              totalSaldo: totalSaldo
            }
            result.push(res[key])
          } else {
            if (value.type === 'in') {
              res[key].qtyIn = parseFloat(res[key].qtyIn) + parseFloat(value.cost_qty)
              res[key].priceIn = value.cost_amount
              res[key].uomIn = value.uom_id
              res[key].refNoIn = value.ref_no
              res[key].statusIn = value.status
              if (value.status === 'inventory') {
                res[key].vendor = value.inventory.vendor
              } else {
                res[key].vendor = value.purchasing.vendor
              }
              res[key].totalIn += parseFloat(value.cost_qty) * parseFloat(value.cost_amount)
            } else if (value.type === 'out') {
              res[key].qtyOut = parseFloat(res[key].qtyOut) + parseFloat(value.cost_qty)
              res[key].priceOut = value.cost_amount
              res[key].uomOut = value.uom_id
              res[key].refNoOut = value.ref_no
              res[key].statusOut = value.status
              res[key].customer = value.sales.customer
              res[key].out.push({
                qtyOut: value.cost_qty,
                uomOut: value.uom_id,
                priceOut: value.cost_amount,
                refNoOut: value.ref_no,
                customer: value.sales.customer,
                status: value.status,
                notes: value.notes
              })
              res[key].totalOut += parseFloat(value.cost_qty) * parseFloat(value.cost_amount)
            } else if (value.type === 'saldo') {
              res[key].qtySaldo = parseFloat(res[key].qtySaldo) + parseFloat(value.cost_qty)
              res[key].uomSaldo = value.uom_id
              res[key].priceSaldo = value.cost_average
              res[key].saldo.push({
                qtySaldo: value.cost_qty,
                uomSaldo: value.uom_id,
                priceSaldo: value.cost_average,
                refNoSaldo: value.ref_no,
                status: value.status,
                queue_saldo: value.queue_saldo,
                notes: value.notes
              })
              res[key].totalSaldo += parseFloat(value.cost_qty) * parseFloat(value.cost_average)
            }
            res[key].price = parseFloat(res[key].price) + parseFloat(value.cost_amount)
          }
          return res
        }, {})
      }
      // return result
      var col = 'date'
      var ascending = true
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return result.sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      })
    },
    mergeColl () {
      var loop = []
      var array = this.journal
      for (let i = 0; i < array.length; i++) {
        var obj = {
          product_no: array[i].product_no,
          product_type: array[i].product_type,
          debit: array[i].debit,
          credit: array[i].credit
        }
        loop.push(obj)
      }
      var array2 = this.dataBefore
      for (let z = 0; z < array2.length; z++) {
        var obj2 = {
          product_no: array2[z].product_no,
          product_type: array2[z].product_type,
          debit: array2[z].debit,
          credit: array2[z].credit
        }
        loop.push(obj2)
      }
      var array3 = this.dataAccount
      for (let b = 0; b < array3.length; b++) {
        var obj3 = {
          product_no: array3[b].product_no,
          product_type: array3[b].product_type,
          debit: array3[b].debit,
          credit: array3[b].credit
        }
        loop.push(obj3)
      }
      return loop
    },
    groupMergeColl () {
      var result = []
      if (this.mergeColl.length > 0) {
        this.mergeColl.reduce(function (res, value) {
          var key = value.product_no
          if (!res[key]) {
            var saldo = parseFloat(value.debit) - parseFloat(value.credit)
            res[key] = {
              product_no: key,
              product_type: value.product_type,
              debit: parseFloat(value.debit),
              credit: parseFloat(value.credit),
              saldo: saldo
            }
            result.push(res[key])
          } else {
            res[key].debit = parseFloat(res[key].debit) + parseFloat(value.debit)
            res[key].credit = parseFloat(res[key].credit) + parseFloat(value.credit)
            res[key].saldo = res[key].debit - res[key].credit
          }
          return res
        }, {})
      }
      return result
    },
    totalgroupMergeColl () {
      var array = this.groupMergeColl
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].saldo)
      }
      return sum
    },
    totalDebitAccountsaldo () {
      var array = this.dataAccount
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].debit)
      }
      return sum
    },
    totalCreditAccountsaldo () {
      var array = this.dataAccount
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].credit)
      }
      return sum
    },
    productselect: function () {
      var loop = []
      var array = this.productListSelect
      for (var x = 0; x < array.length; x++) {
        var obj = {
          product: '[' + array[x].product_no + ']' + ' - ' + array[x].product_name,
          meta: {
            code: array[x].product_no
          }
        }
        loop.push(obj)
      }
      return loop
    },
    contactSelect: function () {
      var loop = []
      for (let i = 0; i < this.contactList.length; i++) {
        var obj = {
          contact: this.contactList[i].contact_no + ' - ' + this.contactList[i].contact_name,
          meta: {
            code: this.contactList[i].contact_no
          }
        }
        loop.push(obj)
      }
      return loop
    },
    totalCredit () {
      var sum = 0
      var array = this.journal
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].credit)
      }
      return sum
    },
    totalDebit () {
      var sum = 0
      var array = this.journal
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].debit)
      }
      return sum
    },
    companyData () {
      var company = null
      if (this.company_no === null) {
        company = this.authUser.company_no
      }
      return company
    },
    getAccountSelect: function () {
      var array = this.accountList
      var loop = []
      for (let i = 0; i < array.length; i++) {
        var obj = {
          account: [array[i].account_code] + ' ' + array[i].account_name,
          meta: {
            code: array[i].account_code
          }
        }
        loop.push(obj)
      }
      return loop
    }
  },
  methods: {
    showReturSales (no) {
      var payload = {
        return_no: no
      }
      this.$store.commit('SET_RETURN_BY_NO', payload)
      this.$store.dispatch('getReturnByNo', payload)
    },
    showSaleNo (no) {
      var payload = {
        sale_no: no
      }
      this.$store.commit('SET_SALE_BY_NO', payload)
      this.$store.dispatch('getSaleByNo', payload)
    },
    async getProductCost () {
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var obj = {
        begin: begin,
        end: end,
        product_no: this.product_no,
        company_no: null
      }
      console.log(obj)
      await Axios.post(productUrl + '/cost/get-product', obj, { headers: getHeader() })
        .then(response => {
          this.dataCost = response.data.data
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Cost', error.response.data.message, 'error')
          throw error
        })
      await this.setCost()
    },
    async setCost () {
      var array = this.journal
      for (let i = 0; i < array.length; i++) {
        // console.log(array[i])
        for (let a = 0; a < this.groupCost.length; a++) {
          console.log(this.groupCost[a].refNoIn + ' ><' + array[i].j_ref_no)
          if (array[i].j_ref_no === this.groupCost[a].refNoIn) {
            array[i].cost = parseFloat(this.groupCost[a].qtyIn) * parseFloat(this.groupCost[a].priceIn)
          } else if (array[i].j_ref_no === this.groupCost[a].refNoOut) {
            array[i].cost = parseFloat(this.groupCost[a].qtyOut) * parseFloat(this.groupCost[a].priceOut)
          }
          if (parseFloat(array[i].debit) === 0) {
            array[i].diff = parseFloat(array[i].credit) - parseFloat(array[i].cost)
          } else {
            array[i].diff = parseFloat(array[i].debit) - parseFloat(array[i].cost)
          }
        }
      }
    },
    editJournal (id) {
      this.$store.dispatch('getJournal', id)
    },
    refreshList () {
      this.$Progress.start()
      this.loader.isLoading = true
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var data = {
        account: this.account_code,
        begin: begin,
        end: end,
        contact: this.contact,
        product_no: this.product_no,
        term: this.term
      }
      console.log(data)
      var url = financeUrl + '/buku-besar-persediaan'
      console.log(url)
      Axios.post(url, data, { headers: getHeader() })
        .then(response => {
          console.log(response.data.data)
          this.journal = response.data.data
          this.saldoAwal = response.data.saldoAwal
          this.saldoRange = response.data.saldoRange
          this.saldoAkhir = response.data.saldoAkhir
          this.dataAccount = response.data.dataAccount
          this.dataBefore = response.data.dataBefore
          this.$Progress.finish()
          this.loader.isLoading = false
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$Progress.fail()
          this.loader.isLoading = false
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    async print (type) {
      this.$Progress.start()
      this.loader.isLoading = true
      var data = {
        format: type,
        data: this.journal,
        saldoAwal: this.saldoAwal,
        totalDebit: this.totalDebit,
        totalCredit: this.totalCredit,
        saldoRange: this.saldoRange,
        saldoAkhir: this.saldoAkhir
      }
      if (data.length === 0) {
        this.$swal('Error', 'Data masih kosong', 'error')
        return false
      }
      console.log(data)
      await Axios.post(report2Url + '/buku-besar', data, { responseType: 'blob' })
        .then(response => {
          const objectUrl = URL.createObjectURL(response.data)
          console.log('Showing PDF...')
          window.open(objectUrl, '_blank')
          this.$Progress.finish()
          this.loader.isLoading = false
        })
        .catch(error => {
          this.$Progress.finish()
          this.loader.isLoading = false
          console.log(error)
          console.log(error.response)
        })
    }
  }
}
</script>
